import type { ProgressionSchema } from '@/types/schema';

import { getServices } from '~/db/services';

export const useProgressionsSyncGet = (memberId: string, type: string) => {
  const { $db } = useNuxtApp();
  const { progressionsService } = getServices($db);
  const ids = ref<string[]>([]);

  const request = ref<() => Promise<ProgressionSchema[]>>(() => {
    try {
      return progressionsService.findByTypeIdsAndMemberId(
        type,
        ids.value,
        memberId
      );
    } catch (e) {
      if (e.name === 'DatabaseClosedError') {
        globalThis.$logger.info('useProgressionsSyncGet :: error', e);
      } else {
        throw e;
      }
    }
  });

  const { value: progressions, release } = useLiveQueryComponent<
    ProgressionSchema[]
  >(request.value, ids);

  $db.progressions.hook('deleting', () => {
    globalThis.$logger.info('progressions is deleting');
    release();
  });

  onUnmounted(() => {
    release();
  });

  return { progressions, ids };
};
